<div>
  <h1>بروزرسانی سرور</h1>
  <h2>توسعه دهندگان ما در حال بروزرسانی سیستم شما هستند. لطفا صبر کنید تا این کار را انجام دهیم</h2>
</div>
